module.exports = __webpack_public_path__ + "static/img/end.9687f898.svg";